import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { COMPANY_TYPES } from '../../../../utils/common'
import { selectCompanyInfo } from '../../../common/header/companyInfo/store/slice'
import { TITLE_TABLE_HEADER } from './constant'

export const NetValueCell = ({ val }) => {
  const { companyType } = useSelector(selectCompanyInfo)

  return companyType === COMPANY_TYPES.CORPORATE ? (
    <Translate value={TITLE_TABLE_HEADER.NET_REVENUE.corpLabel} />
  ) : [COMPANY_TYPES.LIFE_INSURANCE, COMPANY_TYPES.NON_LIFE_INSURANCE].includes(
      companyType,
    ) ? (
    <Translate value={TITLE_TABLE_HEADER.NET_REVENUE.lifeInsLabel} />
  ) : (
    val
  )
}
